export default "https://cdn-static.gokick.com/assets/316c05c5b819a67ca00dcd3ca58b5d19adb19ecb/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";